// B1.4: incidents domain methods (move-only from client.ts).
import { ApiClientCore, buildQueryString } from './http/core';

export class IncidentsApi extends ApiClientCore {
  // ─── Incidents ──────────────────────────────────────────────────────────────
  async getIncidents(params: Record<string, any> = {}): Promise<any> {
    return this.get(`/api/v1/incidents${buildQueryString(params)}`);
  }
  async getIncident(id: number): Promise<any> {
    return this.get(`/api/v1/incidents/${id}`);
  }
  async getIncidentStats(params?: { location_id?: number }): Promise<any> {
    return this.get(`/api/v1/incidents/stats${buildQueryString(params || {})}`);
  }
  async createIncident(data: any): Promise<any> {
    return this.post('/api/v1/incidents', data);
  }
  async updateIncident(id: number, data: any): Promise<any> {
    return this.put(`/api/v1/incidents/${id}`, data);
  }

  async addIncidentPhoto(incidentId: number, fileId: number, description?: string): Promise<any> {
    return this.post(`/api/v1/incidents/${incidentId}/photos`, {
      file_id: fileId,
      description,
    });
  }

  async takeIncident(id: number): Promise<any> {
    return this.put(`/api/v1/incidents/${id}/take`, {});
  }

  async completeIncident(id: number, data?: { resolution_notes?: string }): Promise<any> {
    return this.put(`/api/v1/incidents/${id}/complete`, data || {});
  }

  async cancelIncident(id: number, data: { cancellation_comment: string }): Promise<any> {
    return this.put(`/api/v1/incidents/${id}/cancel`, data);
  }

  /** TIW F3/F6: unified entity_attachments */
  async addIncidentAttachment(
    incidentId: number,
    data: { file_id: number; role: 'brief' | 'result'; media_type?: 'photo' | 'voice' | 'video' }
  ): Promise<any> {
    return this.post(`/api/v1/incidents/${incidentId}/attachments`, data);
  }
}
